import { Icon } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import PrimaryButton from "../../../../ui/components/Buttons/PrimaryButton";

export default function DoneOrNotifyButton({ onOpenNotifyModal, onStopBooking, modifiedSessions }) {
	const { t } = useTranslation();

	return (
		<>
			{modifiedSessions && (
				<PrimaryButton icon labelPosition="right" size="tiny" onClick={onOpenNotifyModal}>
					{t("notify", "Notify")}
					<Icon
						name="close"
						onClick={(e) => {
							e.stopPropagation();
							onStopBooking();
						}}
					/>
				</PrimaryButton>
			)}

			{!modifiedSessions && (
				<PrimaryButton size="tiny" onClick={onStopBooking}>
					{t("ready", "Done")}
				</PrimaryButton>
			)}
		</>
	);
}
